export const configureEditUser = (formValues, editorId, orgId) => {
  const { phone, permissions } = formValues;
  return {
    phone: phone ? phone.trim() : "",
    permissions: permissions ? permissions : "admin",
    updatedOn: new Date(),
    updatedBy: editorId,
  };
};
